// release-notes.component.ts
import { Component } from '@angular/core';

interface ReleaseNote {
  version: string;
  date: string;
  summary: string;
  expanded: boolean;
  features?: string[];
  improvements?: string[];
  bugfixes?: string[];
  breaking: string[];
}

@Component({
    selector: 'app-release-notes',
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.css'],
    standalone: false
})
export class ReleaseNotesComponent {
  releases: ReleaseNote[] = [
    {
      version: 'v6.4.0',
      date: 'April 7, 2025',
      summary: 'Bulk Download service for sequecnce search results',
      expanded: false,
      features: [
        'Implemented Download service for sequecnce search results ',
      ], 
      improvements: [
        'Refactor PAE into heatmap',
      ],
      bugfixes: [
        'Domains track alignments with PAE',
      ],
      breaking: []
    },
    {
      version: 'v6.3.2',
      date: 'March 17, 2025',
      summary: 'Bulk Download service for sequecnce search results',
      expanded: false,
      features: [],
      improvements: [
        'BETA sign removed from the search',
      ],
      bugfixes: [
        'Foldseek Edge case scenarios handled when it resets the database',
      ],
      breaking: []
    },
    {
      version: 'v6.3.0',
      date: 'March 3, 2025',
      summary: 'Domains and bulk download service',
      expanded: false,
      features: [
        'Domians tracks added on entry page',
        'Buld Download service implemented on search results page',
        'Buld Download service implemented on foldseek table on entry page'
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    }
  ];

  toggleExpand(release: ReleaseNote): void {
    release.expanded = !release.expanded;
  }
}
